import { Component, inject } from '@angular/core';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { HttpResourceRef } from '@angular/common/http';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ProfileService } from '../../services/profile.service';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-dashboard-client-stats',
  imports: [TranslateModule, IconComponent, UpperFirstLetterPipe, SkeletonComponent],
  templateUrl: './dashboard-client-stats.html',
  styleUrl: './dashboard-client-stats.scss',
})
export class DashboardClientStats {
  protected readonly profileService = inject(ProfileService);
  protected readonly profileRessouce: HttpResourceRef<any> = this.profileService.profileRessources;
}
